import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ViewChild, ElementRef } from '@angular/core';
import { CategoryService } from '../category.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-eventspage',
  templateUrl: './eventspage.component.html',
  styleUrl: './eventspage.component.css'
})
export class EventspageComponent {

  textInput: string = '';
  openSection: string = '';
  documentFile: File | null = null;
  noOptionField: string = '';
  profileData: any;
  defaultCategoryId: number = 0;
  categoryId: any;
  voucherCategories: any[] = [];
  isUploading: boolean = false;

  addressForm!: FormGroup;
  isEditing = false;
  showNavigationButtons = false;
  showImageSection = false;
  showAddressSection = true;
  imageSelected = false;
  selectedImageFile: File | null = null;
  calculatedDistance: number = 0;
  insertId : any;
  fullAddress : any;
  lat1: number = 0;
  lon1: number = 0;
  lat2: number = 0;
  lon2: number = 0;


  token : any = '609615431cd8d539b733876c7e0c511dSAGLcHZ6nxEBnE4XlJ1nmcPTZaOXOGIXW';
  googlemapApiKey: string = 'AIzaSyBqc5qYO9q2S7XV1As9woAofARrSyPIVBg';

  constructor(private http: HttpClient,
    private categoryService: CategoryService,
    private route: ActivatedRoute,
    private router: Router,
    private scroller: ViewportScroller,
    private fb: FormBuilder
  ) {}
  ngOnInit() : void{
    window.scrollTo(0, 0);
    this.profileData = localStorage.getItem('profileData');

    this.addressForm = this.fb.group({
      address: [''],
      pin: [''],
      city: [''],
      state: [''],
      addressLine2: ['']
    });

    this.fetchAddressFromLocalStorage();

    // fetch categories
    this.fetchVoucherCategories();
    this.route.queryParams.subscribe(params => {
      this.categoryId = +params['categoryId'];
    });
   }

   @ViewChild('videoElement') videoElementRef!: ElementRef;
   @ViewChild('canvasElement') canvasElementRef!: ElementRef;

   capturedImage: string | null = null;



  toggleSection(section: string) {
    if (this.openSection === section) {
      this.openSection = '';
    } else {
      this.openSection = section;

      setTimeout(() => {
        if (section === 'text') {
          this.scroller.scrollToAnchor('divNote');

        } else if (section === 'document') {
          this.scroller.scrollToAnchor('divSelfie');
        }
      }, 100);
    }
  }

  // Camera upload function
  openCamera(): void {
    const videoElement = this.videoElementRef.nativeElement;

    // Access the user's camera using getUserMedia
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        videoElement.srcObject = stream;  // Stream the video feed into the video element
      })
      .catch((err) => {
        console.error('Error accessing camera: ', err);
      });
  }

  captureImage(): void {
    const videoElement = this.videoElementRef.nativeElement;
    const canvasElement = this.canvasElementRef.nativeElement;

    // Set canvas dimensions to match the video element's dimensions
    canvasElement.width = videoElement.videoWidth;
    canvasElement.height = videoElement.videoHeight;

    // Draw the current video frame onto the canvas
    const context = canvasElement.getContext('2d');
    if (context) {
      context.drawImage(videoElement, 0, 0, canvasElement.width, canvasElement.height);

      // Get the image data URL from the canvas
      this.capturedImage = canvasElement.toDataURL('image/png');
    }
  }

  stopCamera(): void {
    const videoElement = this.videoElementRef.nativeElement;
    const stream = videoElement.srcObject as MediaStream;
    if (stream) {
      const tracks = stream.getTracks();
      tracks.forEach(track => track.stop());
      videoElement.srcObject = null;
    }
  }

  uploadFromFolder(event: any) {
    this.documentFile = null;
    const file = event.target.files[0];

    if (!file) return;

    // Check if it's a video
    if (!file.type.startsWith('video/')) {
      alert('Please upload a valid video file.');
      return;
    }

    // Limit size to 500MB
    const maxSizeInMB = 500;
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

    if (file.size > maxSizeInBytes) {
      alert('Maximum file size of 500 MB is not allowed.');
      event.target.value = '';
      this.documentFile = null;
      return;
    }

     this.documentFile = file;
    console.log('Video file accepted:', file);
  }


  // Folder upload function
  // uploadFromFolder(event: any): void {
  //   console.log('Folder upload clicked');
  //   const fileInput = event.target.files[0];
  //   if (fileInput) {
  //     this.documentFile = fileInput;
  //   }
  // }

  fetchVoucherCategories(): void {
    this.categoryService.getCategoryList().subscribe(response => {
      this.voucherCategories = response.response.data;

      // Automatically select first category as default
      if (this.voucherCategories?.length) {
        this.defaultCategoryId = this.voucherCategories[0].id; // adjust field name if different
      }
    });
  }

  redirectToVoucherPage(categoryId: number): void {
    this.router.navigate(['/giftvoucher'], { queryParams: { categoryId } });
  }

  // Text Upload
  uploadText(): void {
    const userCode = JSON.parse(this.profileData).user_code;
    // const categoryId = this.defaultCategoryId;

    this.categoryService.checkOfferRedemption(userCode, this.token).subscribe((response:any) => {
    console.log('Offer redemption response:', response);
      if (response.response.status === 1) {
        alert(response.response.msg);
      } else if (response.response.status === 0) {
        const formData = new FormData();
        formData.append('button_name', 'Text Upload');
        formData.append('text_input', this.textInput);

        if (this.documentFile) {
          formData.append('document_file', this.documentFile);
        }

        formData.append('no_option_field', this.noOptionField);
        formData.append('user_code', userCode);
        formData.append('is_active', '1');
        formData.append('token', this.token);

        this.categoryService.insertUserAction(formData).subscribe(response => {
          console.log('Text upload response:', response);
          alert('Note Saved!');

          if (this.defaultCategoryId) {
            this.redirectToVoucherPage(this.defaultCategoryId);
          } else {
            console.error('No category ID found to redirect');
          }
        });
      }
    }, error => {
      console.error('Error checking offer redemption:', error);
      alert('Error checking offer redemption. Please try again.');
    });
  }

  // uploadText(): void {
  //   const userCode = JSON.parse(this.profileData).user_code;
  //   const formData = new FormData();
  //   formData.append('button_name', 'Text Upload');
  //   formData.append('text_input', this.textInput);
  //   if (this.documentFile) {
  //     formData.append('document_file', this.documentFile);
  //   }
  //   formData.append('no_option_field', this.noOptionField);
  //   formData.append('user_code', userCode);
  //   formData.append('is_active', '1');
  //   formData.append('token', this.token);

  //   this.categoryService.insertUserAction(formData).subscribe(response => {
  //     console.log('Text upload response:', response);
  //     alert('Text uploaded successfully!');

  //     if (this.defaultCategoryId) {
  //       this.redirectToVoucherPage(this.defaultCategoryId);
  //     } else {
  //       console.error('No category ID found to redirect');
  //     }
  //   });
// }

  // Document Upload
  uploadDocument(): void {
    if (!this.documentFile) {
      alert('No valid video file selected.');
      return;
    }

    const maxSizeInBytes = 500 * 1024 * 1024;
    if (this.documentFile.size > maxSizeInBytes) {
      alert('File size exceeds the maximum limit of 500 MB.');
      return;
    }

    this.isUploading = true;
    const userCode = JSON.parse(this.profileData).user_code;

    if (this.documentFile) {
      const formData = new FormData();
      formData.append('video_file', this.documentFile);
      formData.append('button_name', 'Video File');
      formData.append('no_option_field', this.noOptionField);
      formData.append('user_code', userCode);
      formData.append('is_active', '1');
      formData.append('token', this.token);

      this.categoryService.insertUserAction(formData).subscribe(response => {
        console.log('Document upload response:', response);
        alert('Your video has been successfully Captured!');
         this.isUploading = false;

        if (this.defaultCategoryId) {
          this.redirectToVoucherPage(this.defaultCategoryId);
        } else {

          console.error('No category ID found to redirect');
           this.isUploading = false;
        }
      });
    }
  }
  // // uploadText(): void {
  // //   const userCode = JSON.parse(this.profileData).user_code;
  // //   const formData = new FormData();
  // //   formData.append('button_name', 'Text Upload');
  // //   formData.append('text_input', this.textInput);
  // //   if (this.documentFile) {
  // //     formData.append('document_file', this.documentFile);
  // //   }
  // //   formData.append('no_option_field', this.noOptionField);
  // //   formData.append('user_code', userCode);
  // //   formData.append('is_active', '1');
  // //   formData.append('token', this.token);

  // //   this.categoryService.insertUserAction(formData).subscribe(response => {
  // //     console.log('Text upload response:', response);
  // //     alert('Text uploaded successfully!');

  // //     if (this.defaultCategoryId) {
  // //       this.redirectToVoucherPage(this.defaultCategoryId);
  // //     } else {
  // //       console.error('No category ID found to redirect');
  // //     }
  // //   });
  // // }

  // // Document Upload
  // uploadDocument(): void {
  //   const userCode = JSON.parse(this.profileData).user_code;
  //   if (this.documentFile) {
  //     const formData = new FormData();
  //     formData.append('document_file', this.documentFile);
  //     formData.append('button_name', 'Document Upload');
  //     formData.append('text_input', '');
  //     formData.append('document_file', this.documentFile.name);
  //     formData.append('no_option_field', this.noOptionField);
  //     formData.append('user_code', userCode);
  //     formData.append('is_active', '1');
  //     formData.append('token', this.token);

  //     this.categoryService.insertUserAction(formData).subscribe(response => {
  //       console.log('Document upload response:', response);
  //       alert('Selfie Captured!');

  //       if (this.defaultCategoryId) {
  //         this.redirectToVoucherPage(this.defaultCategoryId);
  //       } else {
  //         console.error('No category ID found to redirect');
  //       }
  //     });
  //   }
  // }

  // Redirect Action
  redirectAction(): void {
    const userCode = JSON.parse(this.profileData).user_code;
    const formData = new FormData();
    formData.append('button_name', 'Redirect Action');
    formData.append('text_input', '');
    formData.append('document_file', '');
    formData.append('no_option_field', this.noOptionField);
    formData.append('user_code', userCode);
    formData.append('is_active', '1');
    formData.append('token', this.token);

    this.categoryService.insertUserAction(formData).subscribe(response => {
      console.log('Redirect response:', response);
      if (this.defaultCategoryId) {
        this.redirectToVoucherPage(this.defaultCategoryId);
      } else {
        console.error('No category ID found to redirect');
      }
    });
  }



  fetchAddressFromLocalStorage() {
    const storedData = localStorage.getItem('profileData');
    console.log('Stored Data:', storedData);
    if (storedData) {
      const profile = JSON.parse(storedData);
      this.addressForm.patchValue({
        address: profile.firm_address || '',
        pin: profile.firm_pin || '',
        city: profile.firm_city || '',
        state: profile.firm_state || ''
      });
    } else {
      console.warn('No profile data found in localStorage.');
    }
  }

  edit() {
    this.isEditing = true;
  }

  update() {
    console.log(this.addressForm.value);
    this.isEditing = false;
    this.showNavigationButtons = true;
    this.showAddressSection = false;
    this.getlatlngFromAddress();
  }

  confirm() {
    this.showNavigationButtons = true;
    this.showAddressSection = false;
    this.getlatlngFromAddress();
  }

  goToPrevious() {
    this.showImageSection = false;
    this.showAddressSection = true;
  }

  goToNext() {
    this.showAddressSection = false;
    this.showImageSection = true;
  }

  onFileSelected(event: any) {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const lat = position.coords.latitude.toFixed(5);
        const lng = position.coords.longitude.toFixed(5);
        const text = `Lat: ${lat}, Lng: ${lng}`;
        this.lat2 = parseFloat(lat);
        this.lon2 = parseFloat(lng);
        console.log(`${this.lat1},${this.lon1} and ${this.lat2},${this.lon2}`);

        const file = event.target.files[0];
        if (file) {
          this.selectedImageFile = file;
          this.imageSelected = true;
        }

        const distance = this.distanceCheck(this.lat1, this.lon1, this.lat2, this.lon2);
        this.calculatedDistance = distance;
        console.log(distance);
        if( distance > 50) {
          alert("You are more than 50 meters away from the address you entered. Please try again.");
          return
        }
        // const file = event.target.files[0];
        console.log('Selected file:', file);
        }, error => {
          alert("Failed to get location.");
        });
      } else {
        alert("Geolocation not supported.");
      }
  }

  saveImageData(insertId: any) {
    console.log('Saving image data...');
    if (!this.selectedImageFile) {
      alert("Please select an image first.");
      return;
    }

    const userCode = JSON.parse(this.profileData).user_code;

    const distance = this.distanceCheck(this.lat1, this.lon1, this.lat2, this.lon2);
    this.calculatedDistance = distance;

    const logForm = new FormData();
    logForm.append('insert_id', this.insertId);
    logForm.append('latitude2', this.lat2.toString());
    logForm.append('longitude2', this.lon2.toString());
    logForm.append('distance', distance.toFixed(2));
    logForm.append('confirm_btn2', 'image captured');
    logForm.append('user_action_id', userCode);
    logForm.append('token', this.token);

    this.categoryService.UserActionLogUpdate(logForm).subscribe(
      (res: any) => {
        console.log('UserActionLog (always) response:', res);
      },
      err => {
        console.error('Error in UserActionLog:', err);
      }
    );

    // only when distance <= 50
    if (distance <= 50) {
      const actionForm = new FormData();
      actionForm.append('button_name', 'Image Captured');
      actionForm.append('user_code', userCode);
      actionForm.append('confirm_btn', 'Address Uploaded');
      actionForm.append('address', this.fullAddress);
      // actionForm.append('address', this.addressForm.value.address);
      actionForm.append('latitude1', this.lat1.toString());
      actionForm.append('longitude1', this.lon1.toString());
      actionForm.append('latitude2', this.lat2.toString());
      actionForm.append('longitude2', this.lon2.toString());
      actionForm.append('distance', distance.toFixed(2));
      actionForm.append('token', this.token);

      if (this.selectedImageFile) {
        actionForm.append('image_file', this.selectedImageFile, this.selectedImageFile.name);
      }

      this.categoryService.insertUserAction(actionForm).subscribe(
        res => {
          console.log('insertUserAction (only if ≤ 50m) :', res);
        },
        err => {
          console.error('Error in saving insertuseraction:', err);
        }
      );
    } else {
      alert("You are more than 50 meters away from the address you entered. Please try again.");
    }
  }

  distanceCheck(lat1: number, lon1: number, lat2: number, lon2: number) {

      const toRadians = (deg: number): number => (deg * Math.PI) / 180;

      const R = 6371000;
      const φ1 = toRadians(lat1);
      const φ2 = toRadians(lat2);
      const Δφ = toRadians(lat2 - lat1);
      const Δλ = toRadians(lon2 - lon1);

      const a =
        Math.sin(Δφ / 2) ** 2 +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) ** 2;

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      return R * c;

  }

  // api to get lat and long from address
  getlatlngFromAddress() {
    const address = this.addressForm.value.address;
    const pin = this.addressForm.value.pin;
    const city = this.addressForm.value.city;
    const state = this.addressForm.value.state;

    this.fullAddress = `${address}, ${city}, ${state}, ${pin}`;
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(this.fullAddress)}&key=AIzaSyBqc5qYO9q2S7XV1As9woAofARrSyPIVBg`;
    this.http.get(apiUrl).subscribe((response: any) => {
      if (response.status === 'OK') {
        const location = response.results[0].geometry.location;

        this.lat1= location.lat;
        this.lon1= location.lng;
        console.log('Latitude:', location.lat, 'Longitude:', location.lng);

        const formData = new FormData();
        formData.append('address', this.fullAddress);
        // formData.append('pin', pin);
        // formData.append('city', city);
        // formData.append('state', state);
        formData.append('latitude1', this.lat1.toString());
        formData.append('longitude1', this.lon1.toString());
        formData.append('confirm_btn1', 'address saved');
        formData.append('token', this.token);

        this.categoryService.UserActionLog(formData).subscribe(
          (res: any) => {
            console.log('Address inserted:', res);

            if (res.response && res.response.status === 1) {
              this. insertId = res.response.data.insert_id;

              // this.saveImageData(insertId);
            } else {
              alert('Insert failed: ' + res.response.msg);
            }
          },
          err => {
            console.error('Insert error:', err);
          }
        );

      } else {
        console.error('Geocoding API error:', response.status);
      }
    }, error => {
      console.error('Error fetching geocode:', error);
    });
  }



}
